import request from "@/axios";

/** app插件管理分页查询接口 */
export const getPluginsList = params => {
  return request({
    url: "/lebo-addition/web/appPlugin/page",
    method: "get",
    params
  });
};

/** app插件管理新增数据 */
export const addPlugins = data => {
  return request({
    url: "/lebo-addition/web/appPlugin/save",
    method: "post",
    data
  });
};

/** app插件管理删除数据 */
export const deletePlugins = id => {
  return request({
    url: "/lebo-addition/web/appPlugin/delById",
    method: "get",
    params: {
      id
    }
  });
};

/** 获取阿里云ak和sk */
export const getAliResource = params => {
  return request({
    url: "/lebo-resource/oss/list",
    method: "get",
    params
  });
};
